module.exports = __webpack_public_path__ + "img/philhealth.41834dad.png";